module.exports = __webpack_public_path__ + "img/startPause.72344e03.svg";